import React from "react";
import { Input } from "../Input";
import "./index.scss";

/**
 * @desc Custom File input.
 */
export const File = (props = {}) => {
  props.inputProps.type = "file";

  return <Input {...props} controlled={false} />;
};
